import { observer } from 'mobx-react-lite'
import React from 'react'
import classNames from 'classnames'
import { Button, EnumHelperText, HelperText, Typography } from 'shared/ui'
import { GreetingAudioBlockEditContent } from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder/ui/actions/blocks/GreetingAudioBlock'
import { Brunch } from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder/ui/actions/IVR/ui/IVRActionEditContent/Brunch/Brunch.tsx'
import styles from './styles.module.scss'
import { type IVRStore } from '../../store/IVRStore'

type IActionEditContentProps = {
  store: IVRStore
}

export const IVRActionEditContent = observer(({ store }: IActionEditContentProps) => {
  const { greetingMessageStore, addBranch, branches, disabledAddBranch, branchesError } = store

  const brunchesWithoutNoSelection = branches.slice(0, -1)

  return (
    <div className={styles.wrap}>
      <div>
        <div
          className={classNames(
            styles.header,
            styles.greetingHeader,
            styles[greetingMessageStore.args.audio_url ? 'full' : 'empty']
          )}
        >
          <Typography variant={'body-md-medium'} ariaLabel={'title'}>
            Greeting message
          </Typography>
          <Typography variant={'body-md-regular'} ariaLabel={'desc'} color={'tertiary'}>
            Example: For sales press 1 for support press 2
          </Typography>
        </div>
        <GreetingAudioBlockEditContent store={greetingMessageStore} />
      </div>
      <div>
        <div className={styles.content}>
          <div className={styles.header}>
            <Typography variant={'body-md-medium'} ariaLabel={'title'}>
              Menu options
            </Typography>
            <Typography variant={'body-md-regular'} ariaLabel={'desc'} color={'tertiary'}>
              Keypad options route to set destinations
            </Typography>
          </div>
          {!!brunchesWithoutNoSelection.length && (
            <div className={styles.brunches}>
              {brunchesWithoutNoSelection.map((brunch, index) => (
                <Brunch
                  key={brunch.nextId}
                  brunch={brunch}
                  store={store}
                  withLabel={index === 0}
                  index={index}
                />
              ))}
            </div>
          )}
          <Button
            typeBtn={'contained'}
            contained={'secondary'}
            size={'medium'}
            text={'Add keypad option'}
            icon={'add'}
            onClick={() => addBranch()}
            disabled={disabledAddBranch}
          />
        </div>
        {branchesError && (
          <HelperText
            text={branchesError}
            icon={'alertTriangleSmall'}
            variant={EnumHelperText.Error}
            paddingBlock={'6px'}
          />
        )}
      </div>
    </div>
  )
})
